export default [
  { code: "0049", flag: "🇩🇪", alpha2: "DE", name: "Germany" },
  { code: "0041", flag: "🇨🇭", alpha2: "CH", name: "Switzerland" },
  { code: "0043", flag: "🇦🇹", alpha2: "AT", name: "Austria" },
  { code: "001", flag: "🇨🇦", alpha2: "CA", name: "Canada" },
  { code: "001", flag: "🇺🇸", alpha2: "US", name: "United States" },
  { code: "001242", flag: "🇧🇸", alpha2: "BS", name: "Bahamas" },
  { code: "001246", flag: "🇧🇧", alpha2: "BB", name: "Barbados" },
  { code: "001264", flag: "🇦🇮", alpha2: "AI", name: "Anguilla" },
  { code: "001268", flag: "🇦🇬", alpha2: "AG", name: "Antigua and Barbuda" },
  { code: "001284", flag: "🇻🇬", alpha2: "VG", name: "Virgin Islands, British" },
  { code: "001340", flag: "🇻🇮", alpha2: "VI", name: "Virgin Islands, U.S." },
  { code: "001441", flag: "🇧🇲", alpha2: "BM", name: "Bermuda" },
  { code: "001473", flag: "🇬🇩", alpha2: "GD", name: "Grenada" },
  {
    code: "001649",
    flag: "🇹🇨",
    alpha2: "TC",
    name: "Turks and Caicos Islands",
  },
  { code: "001664", flag: "🇲🇸", alpha2: "MS", name: "Montserrat" },
  {
    code: "001670",
    flag: "🇲🇵",
    alpha2: "MP",
    name: "Northern Mariana Islands",
  },
  { code: "001671", flag: "🇬🇺", alpha2: "GU", name: "Guam" },
  { code: "001684", flag: "🇦🇸", alpha2: "AS", name: "American Samoa" },
  { code: "001758", flag: "🇱🇨", alpha2: "LC", name: "Saint Lucia" },
  { code: "001767", flag: "🇩🇲", alpha2: "DM", name: "Dominica" },
  {
    code: "001784",
    flag: "🇻🇨",
    alpha2: "VC",
    name: "Saint Vincent and the Grenadines",
  },
  { code: "001849", flag: "🇩🇴", alpha2: "DO", name: "Dominican Republic" },
  { code: "001868", flag: "🇹🇹", alpha2: "TT", name: "Trinidad and Tobago" },
  { code: "001869", flag: "🇰🇳", alpha2: "KN", name: "Saint Kitts and Nevis" },
  { code: "001876", flag: "🇯🇲", alpha2: "JM", name: "Jamaica" },
  { code: "001939", flag: "🇵🇷", alpha2: "PR", name: "Puerto Rico" },
  { code: "0020", flag: "🇪🇬", alpha2: "EG", name: "Egypt" },
  { code: "00211", flag: "🇸🇸", alpha2: "SS", name: "South Sudan" },
  { code: "00212", flag: "🇲🇦", alpha2: "MA", name: "Morocco" },
  { code: "00213", flag: "🇩🇿", alpha2: "DZ", name: "Algeria" },
  { code: "00216", flag: "🇹🇳", alpha2: "TN", name: "Tunisia" },
  { code: "00218", flag: "🇱🇾", alpha2: "LY", name: "Libyan Arab Jamahiriya" },
  { code: "00220", flag: "🇬🇲", alpha2: "GM", name: "Gambia" },
  { code: "00221", flag: "🇸🇳", alpha2: "SN", name: "Senegal" },
  { code: "00222", flag: "🇲🇷", alpha2: "MR", name: "Mauritania" },
  { code: "00223", flag: "🇲🇱", alpha2: "ML", name: "Mali" },
  { code: "00224", flag: "🇬🇳", alpha2: "GN", name: "Guinea" },
  { code: "00225", flag: "🇨🇮", alpha2: "CI", name: "Cote d'Ivoire" },
  { code: "00226", flag: "🇧🇫", alpha2: "BF", name: "Burkina Faso" },
  { code: "00227", flag: "🇳🇪", alpha2: "NE", name: "Niger" },
  { code: "00228", flag: "🇹🇬", alpha2: "TG", name: "Togo" },
  { code: "00229", flag: "🇧🇯", alpha2: "BJ", name: "Benin" },
  { code: "00230", flag: "🇲🇺", alpha2: "MU", name: "Mauritius" },
  { code: "00231", flag: "🇱🇷", alpha2: "LR", name: "Liberia" },
  { code: "00232", flag: "🇸🇱", alpha2: "SL", name: "Sierra Leone" },
  { code: "00233", flag: "🇬🇭", alpha2: "GH", name: "Ghana" },
  { code: "00234", flag: "🇳🇬", alpha2: "NG", name: "Nigeria" },
  { code: "00235", flag: "🇹🇩", alpha2: "TD", name: "Chad" },
  { code: "00236", flag: "🇨🇫", alpha2: "CF", name: "Central African Republic" },
  { code: "00237", flag: "🇨🇲", alpha2: "CM", name: "Cameroon" },
  { code: "00238", flag: "🇨🇻", alpha2: "CV", name: "Cape Verde" },
  { code: "00239", flag: "🇸🇹", alpha2: "ST", name: "Sao Tome and Principe" },
  { code: "00240", flag: "🇬🇶", alpha2: "GQ", name: "Equatorial Guinea" },
  { code: "00241", flag: "🇬🇦", alpha2: "GA", name: "Gabon" },
  { code: "00242", flag: "🇨🇬", alpha2: "CG", name: "Congo" },
  {
    code: "00243",
    flag: "🇨🇩",
    alpha2: "CD",
    name: "Congo, The Democratic Republic of the Congo",
  },
  { code: "00244", flag: "🇦🇴", alpha2: "AO", name: "Angola" },
  { code: "00245", flag: "🇬🇼", alpha2: "GW", name: "Guinea-Bissau" },
  {
    code: "00246",
    flag: "🇮🇴",
    alpha2: "IO",
    name: "British Indian Ocean Territory",
  },
  { code: "00248", flag: "🇸🇨", alpha2: "SC", name: "Seychelles" },
  { code: "00249", flag: "🇸🇩", alpha2: "SD", name: "Sudan" },
  { code: "00250", flag: "🇷🇼", alpha2: "RW", name: "Rwanda" },
  { code: "00251", flag: "🇪🇹", alpha2: "ET", name: "Ethiopia" },
  { code: "00252", flag: "🇸🇴", alpha2: "SO", name: "Somalia" },
  { code: "00253", flag: "🇩🇯", alpha2: "DJ", name: "Djibouti" },
  { code: "00254", flag: "🇰🇪", alpha2: "KE", name: "Kenya" },
  {
    code: "00255",
    flag: "🇹🇿",
    alpha2: "TZ",
    name: "Tanzania, United Republic of Tanzania",
  },
  { code: "00256", flag: "🇺🇬", alpha2: "UG", name: "Uganda" },
  { code: "00257", flag: "🇧🇮", alpha2: "BI", name: "Burundi" },
  { code: "00258", flag: "🇲🇿", alpha2: "MZ", name: "Mozambique" },
  { code: "00260", flag: "🇿🇲", alpha2: "ZM", name: "Zambia" },
  { code: "00261", flag: "🇲🇬", alpha2: "MG", name: "Madagascar" },
  {
    code: "00262",
    flag: "🇹🇫",
    alpha2: "TF",
    name: "French Southern Territories",
  },
  { code: "00262", flag: "🇾🇹", alpha2: "YT", name: "Mayotte" },
  { code: "00262", flag: "🇷🇪", alpha2: "RE", name: "Reunion" },
  { code: "00263", flag: "🇿🇼", alpha2: "ZW", name: "Zimbabwe" },
  { code: "00264", flag: "🇳🇦", alpha2: "NA", name: "Namibia" },
  { code: "00265", flag: "🇲🇼", alpha2: "MW", name: "Malawi" },
  { code: "00266", flag: "🇱🇸", alpha2: "LS", name: "Lesotho" },
  { code: "00267", flag: "🇧🇼", alpha2: "BW", name: "Botswana" },
  { code: "00268", flag: "🇸🇿", alpha2: "SZ", name: "Swaziland" },
  { code: "00269", flag: "🇰🇲", alpha2: "KM", name: "Comoros" },
  { code: "0027", flag: "🇿🇦", alpha2: "ZA", name: "South Africa" },
  {
    code: "00290",
    flag: "🇸🇭",
    alpha2: "SH",
    name: "Saint Helena, Ascension and Tristan Da Cunha",
  },
  { code: "00291", flag: "🇪🇷", alpha2: "ER", name: "Eritrea" },
  { code: "00297", flag: "🇦🇼", alpha2: "AW", name: "Aruba" },
  { code: "00298", flag: "🇫🇴", alpha2: "FO", name: "Faroe Islands" },
  { code: "00299", flag: "🇬🇱", alpha2: "GL", name: "Greenland" },
  { code: "0030", flag: "🇬🇷", alpha2: "GR", name: "Greece" },
  { code: "0031", flag: "🇳🇱", alpha2: "NL", name: "Netherlands" },
  { code: "0032", flag: "🇧🇪", alpha2: "BE", name: "Belgium" },
  { code: "0033", flag: "🇫🇷", alpha2: "FR", name: "France" },
  { code: "0034", flag: "🇪🇸", alpha2: "ES", name: "Spain" },
  { code: "00345", flag: "🇰🇾", alpha2: "KY", name: "Cayman Islands" },
  { code: "00350", flag: "🇬🇮", alpha2: "GI", name: "Gibraltar" },
  { code: "00351", flag: "🇵🇹", alpha2: "PT", name: "Portugal" },
  { code: "00352", flag: "🇱🇺", alpha2: "LU", name: "Luxembourg" },
  { code: "00353", flag: "🇮🇪", alpha2: "IE", name: "Ireland" },
  { code: "00354", flag: "🇮🇸", alpha2: "IS", name: "Iceland" },
  { code: "00355", flag: "🇦🇱", alpha2: "AL", name: "Albania" },
  { code: "00356", flag: "🇲🇹", alpha2: "MT", name: "Malta" },
  { code: "00357", flag: "🇨🇾", alpha2: "CY", name: "Cyprus" },
  { code: "00358", flag: "🇦🇽", alpha2: "AX", name: "Åland Islands" },
  { code: "00358", flag: "🇫🇮", alpha2: "FI", name: "Finland" },
  { code: "00359", flag: "🇧🇬", alpha2: "BG", name: "Bulgaria" },
  { code: "0036", flag: "🇭🇺", alpha2: "HU", name: "Hungary" },
  { code: "00370", flag: "🇱🇹", alpha2: "LT", name: "Lithuania" },
  { code: "00371", flag: "🇱🇻", alpha2: "LV", name: "Latvia" },
  { code: "00372", flag: "🇪🇪", alpha2: "EE", name: "Estonia" },
  { code: "00373", flag: "🇲🇩", alpha2: "MD", name: "Moldova" },
  { code: "00374", flag: "🇦🇲", alpha2: "AM", name: "Armenia" },
  { code: "00375", flag: "🇧🇾", alpha2: "BY", name: "Belarus" },
  { code: "00376", flag: "🇦🇩", alpha2: "AD", name: "Andorra" },
  { code: "00377", flag: "🇲🇨", alpha2: "MC", name: "Monaco" },
  { code: "00378", flag: "🇸🇲", alpha2: "SM", name: "San Marino" },
  {
    code: "00379",
    flag: "🇻🇦",
    alpha2: "VA",
    name: "Holy See (Vatican City State)",
  },
  { code: "00380", flag: "🇺🇦", alpha2: "UA", name: "Ukraine" },
  { code: "00381", flag: "🇷🇸", alpha2: "RS", name: "Serbia" },
  { code: "00382", flag: "🇲🇪", alpha2: "ME", name: "Montenegro" },
  { code: "00383", flag: "🇽🇰", alpha2: "XK", name: "Kosovo" },
  { code: "00385", flag: "🇭🇷", alpha2: "HR", name: "Croatia" },
  { code: "00386", flag: "🇸🇮", alpha2: "SI", name: "Slovenia" },
  { code: "00387", flag: "🇧🇦", alpha2: "BA", name: "Bosnia and Herzegovina" },
  { code: "00389", flag: "🇲🇰", alpha2: "MK", name: "North Macedonia" },
  { code: "0039", flag: "🇮🇹", alpha2: "IT", name: "Italy" },
  { code: "0040", flag: "🇷🇴", alpha2: "RO", name: "Romania" },
  { code: "00420", flag: "🇨🇿", alpha2: "CZ", name: "Czech Republic" },
  { code: "00421", flag: "🇸🇰", alpha2: "SK", name: "Slovakia" },
  { code: "00423", flag: "🇱🇮", alpha2: "LI", name: "Liechtenstein" },
  { code: "0044", flag: "🇬🇬", alpha2: "GG", name: "Guernsey" },
  { code: "0044", flag: "🇮🇲", alpha2: "IM", name: "Isle of Man" },
  { code: "0044", flag: "🇯🇪", alpha2: "JE", name: "Jersey" },
  { code: "0044", flag: "🇬🇧", alpha2: "GB", name: "United Kingdom" },
  { code: "0045", flag: "🇩🇰", alpha2: "DK", name: "Denmark" },
  { code: "0046", flag: "🇸🇪", alpha2: "SE", name: "Sweden" },
  { code: "0047", flag: "🇧🇻", alpha2: "BV", name: "Bouvet Island" },
  { code: "0047", flag: "🇳🇴", alpha2: "NO", name: "Norway" },
  { code: "0047", flag: "🇸🇯", alpha2: "SJ", name: "Svalbard and Jan Mayen" },
  { code: "0048", flag: "🇵🇱", alpha2: "PL", name: "Poland" },
  {
    code: "00500",
    flag: "🇫🇰",
    alpha2: "FK",
    name: "Falkland Islands (Malvinas)",
  },
  {
    code: "00500",
    flag: "🇬🇸",
    alpha2: "GS",
    name: "South Georgia and the South Sandwich Islands",
  },
  { code: "00501", flag: "🇧🇿", alpha2: "BZ", name: "Belize" },
  { code: "00502", flag: "🇬🇹", alpha2: "GT", name: "Guatemala" },
  { code: "00503", flag: "🇸🇻", alpha2: "SV", name: "El Salvador" },
  { code: "00504", flag: "🇭🇳", alpha2: "HN", name: "Honduras" },
  { code: "00505", flag: "🇳🇮", alpha2: "NI", name: "Nicaragua" },
  { code: "00506", flag: "🇨🇷", alpha2: "CR", name: "Costa Rica" },
  { code: "00507", flag: "🇵🇦", alpha2: "PA", name: "Panama" },
  {
    code: "00508",
    flag: "🇵🇲",
    alpha2: "PM",
    name: "Saint Pierre and Miquelon",
  },
  { code: "00509", flag: "🇭🇹", alpha2: "HT", name: "Haiti" },
  { code: "0051", flag: "🇵🇪", alpha2: "PE", name: "Peru" },
  { code: "0052", flag: "🇲🇽", alpha2: "MX", name: "Mexico" },
  { code: "0053", flag: "🇨🇺", alpha2: "CU", name: "Cuba" },
  { code: "0054", flag: "🇦🇷", alpha2: "AR", name: "Argentina" },
  { code: "0055", flag: "🇧🇷", alpha2: "BR", name: "Brazil" },
  { code: "0056", flag: "🇨🇱", alpha2: "CL", name: "Chile" },
  { code: "0057", flag: "🇨🇴", alpha2: "CO", name: "Colombia" },
  {
    code: "0058",
    flag: "🇻🇪",
    alpha2: "VE",
    name: "Venezuela, Bolivarian Republic of Venezuela",
  },
  { code: "00590", flag: "🇬🇵", alpha2: "GP", name: "Guadeloupe" },
  { code: "00590", flag: "🇧🇱", alpha2: "BL", name: "Saint Barthelemy" },
  { code: "00590", flag: "🇲🇫", alpha2: "MF", name: "Saint Martin" },
  {
    code: "00591",
    flag: "🇧🇴",
    alpha2: "BO",
    name: "Bolivia, Plurinational State of bolivia",
  },
  { code: "00592", flag: "🇬🇾", alpha2: "GY", name: "Guyana" },
  { code: "00593", flag: "🇪🇨", alpha2: "EC", name: "Ecuador" },
  { code: "00594", flag: "🇬🇫", alpha2: "GF", name: "French Guiana" },
  { code: "00595", flag: "🇵🇾", alpha2: "PY", name: "Paraguay" },
  { code: "00596", flag: "🇲🇶", alpha2: "MQ", name: "Martinique" },
  { code: "00597", flag: "🇸🇷", alpha2: "SR", name: "Suriname" },
  { code: "00598", flag: "🇺🇾", alpha2: "UY", name: "Uruguay" },
  { code: "00599", flag: "", alpha2: "AN", name: "Netherlands Antilles" },
  { code: "0060", flag: "🇲🇾", alpha2: "MY", name: "Malaysia" },
  { code: "0061", flag: "🇦🇺", alpha2: "AU", name: "Australia" },
  { code: "0061", flag: "🇨🇽", alpha2: "CX", name: "Christmas Island" },
  { code: "0061", flag: "🇨🇨", alpha2: "CC", name: "Cocos (Keeling) Islands" },
  { code: "0062", flag: "🇮🇩", alpha2: "ID", name: "Indonesia" },
  { code: "0063", flag: "🇵🇭", alpha2: "PH", name: "Philippines" },
  { code: "0064", flag: "🇳🇿", alpha2: "NZ", name: "New Zealand" },
  { code: "0064", flag: "🇵🇳", alpha2: "PN", name: "Pitcairn" },
  { code: "0065", flag: "🇸🇬", alpha2: "SG", name: "Singapore" },
  { code: "0066", flag: "🇹🇭", alpha2: "TH", name: "Thailand" },
  { code: "00670", flag: "🇹🇱", alpha2: "TL", name: "Timor-Leste" },
  { code: "00672", flag: "🇦🇶", alpha2: "AQ", name: "Antarctica" },
  {
    code: "00672",
    flag: "🇭🇲",
    alpha2: "HM",
    name: "Heard Island and Mcdonald Islands",
  },
  { code: "00672", flag: "🇳🇫", alpha2: "NF", name: "Norfolk Island" },
  { code: "00673", flag: "🇧🇳", alpha2: "BN", name: "Brunei Darussalam" },
  { code: "00674", flag: "🇳🇷", alpha2: "NR", name: "Nauru" },
  { code: "00675", flag: "🇵🇬", alpha2: "PG", name: "Papua New Guinea" },
  { code: "00676", flag: "🇹🇴", alpha2: "TO", name: "Tonga" },
  { code: "00677", flag: "🇸🇧", alpha2: "SB", name: "Solomon Islands" },
  { code: "00678", flag: "🇻🇺", alpha2: "VU", name: "Vanuatu" },
  { code: "00679", flag: "🇫🇯", alpha2: "FJ", name: "Fiji" },
  { code: "00680", flag: "🇵🇼", alpha2: "PW", name: "Palau" },
  { code: "00681", flag: "🇼🇫", alpha2: "WF", name: "Wallis and Futuna" },
  { code: "00682", flag: "🇨🇰", alpha2: "CK", name: "Cook Islands" },
  { code: "00683", flag: "🇳🇺", alpha2: "NU", name: "Niue" },
  { code: "00685", flag: "🇼🇸", alpha2: "WS", name: "Samoa" },
  { code: "00686", flag: "🇰🇮", alpha2: "KI", name: "Kiribati" },
  { code: "00687", flag: "🇳🇨", alpha2: "NC", name: "New Caledonia" },
  { code: "00688", flag: "🇹🇻", alpha2: "TV", name: "Tuvalu" },
  { code: "00689", flag: "🇵🇫", alpha2: "PF", name: "French Polynesia" },
  { code: "00690", flag: "🇹🇰", alpha2: "TK", name: "Tokelau" },
  {
    code: "00691",
    flag: "🇫🇲",
    alpha2: "FM",
    name: "Micronesia, Federated States of Micronesia",
  },
  { code: "00692", flag: "🇲🇭", alpha2: "MH", name: "Marshall Islands" },
  { code: "007", flag: "🇰🇿", alpha2: "KZ", name: "Kazakhstan" },
  { code: "007", flag: "🇷🇺", alpha2: "RU", name: "Russia" },
  { code: "0081", flag: "🇯🇵", alpha2: "JP", name: "Japan" },
  {
    code: "0082",
    flag: "🇰🇷",
    alpha2: "KR",
    name: "Korea, Republic of South Korea",
  },
  { code: "0084", flag: "🇻🇳", alpha2: "VN", name: "Vietnam" },
  {
    code: "00850",
    flag: "🇰🇵",
    alpha2: "KP",
    name: "Korea, Democratic People's Republic of Korea",
  },
  { code: "00852", flag: "🇭🇰", alpha2: "HK", name: "Hong Kong" },
  { code: "00853", flag: "🇲🇴", alpha2: "MO", name: "Macao" },
  { code: "00855", flag: "🇰🇭", alpha2: "KH", name: "Cambodia" },
  { code: "00856", flag: "🇱🇦", alpha2: "LA", name: "Laos" },
  { code: "0086", flag: "🇨🇳", alpha2: "CN", name: "China" },
  { code: "00880", flag: "🇧🇩", alpha2: "BD", name: "Bangladesh" },
  { code: "00886", flag: "🇹🇼", alpha2: "TW", name: "Taiwan" },
  { code: "0090", flag: "🇹🇷", alpha2: "TR", name: "Türkiye" },
  { code: "0091", flag: "🇮🇳", alpha2: "IN", name: "India" },
  { code: "0092", flag: "🇵🇰", alpha2: "PK", name: "Pakistan" },
  { code: "0093", flag: "🇦🇫", alpha2: "AF", name: "Afghanistan" },
  { code: "0094", flag: "🇱🇰", alpha2: "LK", name: "Sri Lanka" },
  { code: "0095", flag: "🇲🇲", alpha2: "MM", name: "Myanmar" },
  { code: "00960", flag: "🇲🇻", alpha2: "MV", name: "Maldives" },
  { code: "00961", flag: "🇱🇧", alpha2: "LB", name: "Lebanon" },
  { code: "00962", flag: "🇯🇴", alpha2: "JO", name: "Jordan" },
  { code: "00963", flag: "🇸🇾", alpha2: "SY", name: "Syrian Arab Republic" },
  { code: "00964", flag: "🇮🇶", alpha2: "IQ", name: "Iraq" },
  { code: "00965", flag: "🇰🇼", alpha2: "KW", name: "Kuwait" },
  { code: "00966", flag: "🇸🇦", alpha2: "SA", name: "Saudi Arabia" },
  { code: "00967", flag: "🇾🇪", alpha2: "YE", name: "Yemen" },
  { code: "00968", flag: "🇴🇲", alpha2: "OM", name: "Oman" },
  {
    code: "00970",
    flag: "🇵🇸",
    alpha2: "PS",
    name: "Palestinian Territory, Occupied",
  },
  { code: "00971", flag: "🇦🇪", alpha2: "AE", name: "United Arab Emirates" },
  { code: "00972", flag: "🇮🇱", alpha2: "IL", name: "Israel" },
  { code: "00973", flag: "🇧🇭", alpha2: "BH", name: "Bahrain" },
  { code: "00974", flag: "🇶🇦", alpha2: "QA", name: "Qatar" },
  { code: "00975", flag: "🇧🇹", alpha2: "BT", name: "Bhutan" },
  { code: "00976", flag: "🇲🇳", alpha2: "MN", name: "Mongolia" },
  { code: "00977", flag: "🇳🇵", alpha2: "NP", name: "Nepal" },
  {
    code: "0098",
    flag: "🇮🇷",
    alpha2: "IR",
    name: "Iran, Islamic Republic of Persian Gulf",
  },
  { code: "00992", flag: "🇹🇯", alpha2: "TJ", name: "Tajikistan" },
  { code: "00993", flag: "🇹🇲", alpha2: "TM", name: "Turkmenistan" },
  { code: "00994", flag: "🇦🇿", alpha2: "AZ", name: "Azerbaijan" },
  { code: "00995", flag: "🇬🇪", alpha2: "GE", name: "Georgia" },
  { code: "00996", flag: "🇰🇬", alpha2: "KG", name: "Kyrgyzstan" },
  { code: "00998", flag: "🇺🇿", alpha2: "UZ", name: "Uzbekistan" },
];
